/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ShowVariantDetails.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import PropTypes from "prop-types";
import CustomScrollerTable from "../common/table/CustomScrollerTable";
import { Box } from "@mui/material";

function ShowVariantDetails({
  isVehicleFunction,
  selectedVariantDetails,
  isProjectZones,
  projectDetailsSelected,
  isMilestoneDetails,
  isVariantUsers,
}) {
  return (
    <div>
      {" "}
      <Box sx={{ p: 1 }}>
        <Box>
          {projectDetailsSelected?.is_zonal ? (
            <CustomScrollerTable
              title={isProjectZones?.title}
              count={isProjectZones?.count}
              columns={isProjectZones?.columns}
              rows={isProjectZones?.rows}
              hideAddButton={isProjectZones?.hideAddButton}
              actionIcon={isProjectZones?.actionIcon}
              handleOnClick={isProjectZones?.handleOnClick}
            />
          ) : null}
          <CustomScrollerTable
            title={isVehicleFunction?.title}
            count={isVehicleFunction?.count}
            columns={isVehicleFunction?.columns}
            rows={isVehicleFunction?.rows}
            hideAddButton={isVehicleFunction?.hideAddButton}
            actionIcon={isVehicleFunction?.actionIcon}
            handleOnClick={() =>
              isVehicleFunction.handleOnClick(isVehicleFunction?.title)
            }
          />
          <CustomScrollerTable
            title={isMilestoneDetails?.title}
            count={isMilestoneDetails?.count}
            columns={isMilestoneDetails?.columns}
            rows={isMilestoneDetails?.rows}
            hideAddButton={isMilestoneDetails?.hideAddButton}
            actionIcon={isMilestoneDetails?.actionIcon}
            handleOnClick={isMilestoneDetails?.handleOnClick}
          />
          <CustomScrollerTable
            title={isVariantUsers?.title}
            onlyUsers={isVariantUsers?.onlyUsers}
          />
        </Box>
      </Box>
    </div>
  );
}

ShowVariantDetails.propTypes = {
  isVehicleFunction: PropTypes.shape({
    title: PropTypes.node,
    count: PropTypes.number,
    columns: PropTypes.array,
    rows: PropTypes.array,
    handleOnClick: PropTypes.func,
    hideAddButton: PropTypes.bool,
    actionIcon: PropTypes.string,
  }),
  selectedVariantDetails: PropTypes.object,
  isProjectZones: PropTypes.shape({
    title: PropTypes.node,
    count: PropTypes.number,
    columns: PropTypes.array,
    rows: PropTypes.array,
    hideAddButton: PropTypes.bool,
    actionIcon: PropTypes.string,
    handleOnClick: PropTypes.func,
  }),
  projectDetailsSelected: PropTypes.shape({
    is_zonal: PropTypes.bool,
  }),
  isMilestoneDetails: PropTypes.shape({
    title: PropTypes.node,
    count: PropTypes.number,
    columns: PropTypes.array,
    rows: PropTypes.array,
    hideAddButton: PropTypes.bool,
    actionIcon: PropTypes.string,
    handleOnClick: PropTypes.func,
  }),
  isVariantUsers: PropTypes.shape({
    title: PropTypes.node,
    onlyUsers: PropTypes.any,
  }),
};

export default ShowVariantDetails;
